import { AI_SOURCES } from '@/constants/api';
import { Avatar, AvatarGender, AvatarType } from '@/types/avatar';
import { TAVUS_AVATARS } from './systemTavusAvatars';

export const SYNTHESIA_DEFAULT_AVATARS: Avatar[] = [
  {
    id: '2cd8bfce-6be9-4922-b508-e1194bc49731',
    src: 'https://media.gotolstoy.com/studio/synthesia_avatar_alex.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_alex_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_alex_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_avatar_alex_preview.mp4',
    name: 'Alex',
    source: AI_SOURCES.synthesia,
    approvedForAds: false,
    type: AvatarType.Default,
    avatarId: '2cd8bfce-6be9-4922-b508-e1194bc49731',
    voiceId: '2025b272-7db6-4d6c-b821-3ef674efaafe',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 670, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 454, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: 'b78cab87-5f8b-45d0-8c4b-b96c82c770af',
    src: 'https://media.gotolstoy.com/studio/synthesia_avatar_ada.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_ada_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_ada_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_avatar_ada_preview.mp4',
    name: 'Ada',
    source: AI_SOURCES.synthesia,
    approvedForAds: false,
    type: AvatarType.Default,
    avatarId: 'b78cab87-5f8b-45d0-8c4b-b96c82c770af',
    voiceId: '398dc821-2eb9-4d93-9dca-ff6f3165906a',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 670, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 454, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: 'dd80c440-4a80-4529-b4fc-bcadb590e201',
    src: 'https://media.gotolstoy.com/studio/synthesia_avatar_donna.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_donna_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_donna_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_avatar_donna_preview.mp4',
    name: 'Donna',
    source: AI_SOURCES.synthesia,
    approvedForAds: false,
    type: AvatarType.Default,
    avatarId: 'dd80c440-4a80-4529-b4fc-bcadb590e201',
    voiceId: '2375212d-b46a-4598-b3ba-36b9682098c5',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 800, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 654, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: '81ac733c-bd9a-4b0d-af0d-21885813a136',
    src: 'https://media.gotolstoy.com/studio/synthesia_avatar_joshua.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_joshua_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_joshua_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_avatar_joshua_preview.mp4',
    name: 'Joshua',
    source: AI_SOURCES.synthesia,
    approvedForAds: false,
    type: AvatarType.Default,
    avatarId: '81ac733c-bd9a-4b0d-af0d-21885813a136',
    voiceId: '7185496a-eb1c-4a6d-bcc0-d8ce1cb266ee',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 500, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 454, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Male,
    },
  },
  {
    id: '5c54aee8-a7f2-47a7-a3f6-ca2aad86a074',
    src: 'https://media.gotolstoy.com/studio/synthesia_avatar_ryan.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_ryan_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_avatar_ryan_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_avatar_ryan_preview.mp4',
    name: 'Ryan',
    source: AI_SOURCES.synthesia,
    approvedForAds: false,
    type: AvatarType.Default,
    avatarId: '5c54aee8-a7f2-47a7-a3f6-ca2aad86a074',
    voiceId: '7185496a-eb1c-4a6d-bcc0-d8ce1cb266ee',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 770, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 654, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Male,
    },
  },
];

export const SYNTHESIA_PERSONAL_AVATARS: Avatar[] = [
  {
    id: 'c5c5c640-9b9a-4777-8762-808f6ebc2613',
    src: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_keren_b.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_keren_b_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_keren_b_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_keren_b_preview.mp4',
    name: 'Keren B',
    source: AI_SOURCES.synthesia,
    approvedForAds: true,
    type: AvatarType.Personal,
    avatarId: 'c5c5c640-9b9a-4777-8762-808f6ebc2613',
    voiceId: '0513af20-637a-495d-9145-bb6b6c885af2',
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: '9661366e-b0bc-4413-b1ea-cf3fa247ef66',
    src: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_danielle_h.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_danielle_h_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_danielle_h_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_danielle_h_preview.mp4',
    name: 'Danielle H',
    source: AI_SOURCES.synthesia,
    approvedForAds: true,
    type: AvatarType.Personal,
    avatarId: '9661366e-b0bc-4413-b1ea-cf3fa247ef66',
    voiceId: '1d505dfa-e3e4-4f50-a109-6bb3ef8dec15',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 609, height: 1080, x: 770, y: 0 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 1064, height: 1064, x: 554, y: 0 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: 'd4131c70-d4d6-4f62-919f-dff22970115f',
    src: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_david_c.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_david_c_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_david_c_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_david_c_preview.mp4',
    name: 'David C',
    source: AI_SOURCES.synthesia,
    approvedForAds: true,
    type: AvatarType.Personal,
    avatarId: 'd4131c70-d4d6-4f62-919f-dff22970115f',
    voiceId: 'f1cc48f4-97bf-48c7-92ed-b012450655c8',
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Male,
    },
  },
  {
    id: 'beedf7ff-a63c-44ed-9811-afdee1377ea5',
    src: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_yonah_b.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_yonah_b_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_yonah_b_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_yonah_b_preview.mp4',
    name: 'Yonah B',
    source: AI_SOURCES.synthesia,
    approvedForAds: true,
    type: AvatarType.Personal,
    avatarId: 'beedf7ff-a63c-44ed-9811-afdee1377ea5',
    voiceId: '81935d3a-692a-435f-a4b0-c4987197fcd2',
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Female,
    },
  },
  {
    id: '1f687a30-30b4-4dd3-9d16-0d7e75685eaa',
    src: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_chris_l.webp',
    sources: {
      no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_chris_l_no_bg.png',
      video_preview_no_bg: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_chris_l_preview_no_bg.gif',
    },
    videoPreviewSrc: 'https://media.gotolstoy.com/studio/synthesia_personal_avatar_chris_l_preview.mp4',
    name: 'Chris L',
    source: AI_SOURCES.synthesia,
    approvedForAds: true,
    type: AvatarType.Personal,
    avatarId: '1f687a30-30b4-4dd3-9d16-0d7e75685eaa',
    voiceId: 'd8c96213-7186-4c05-8a88-4c2276e8889c',
    fullscreenFit: {
      type: 'crop',
      crop: { width: 600, height: 1064, x: 660, y: 10 },
    },
    circleFit: {
      type: 'crop',
      crop: { width: 600, height: 600, x: 660, y: 226 },
    },
    hardcoded: true,
    metadata: {
      gender: AvatarGender.Male,
    },
  },
];

export const TOP_AVATARS = [
  ...TAVUS_AVATARS.slice(0, 2),
  ...SYNTHESIA_DEFAULT_AVATARS.slice(0, 2),
  ...SYNTHESIA_PERSONAL_AVATARS.slice(0, 2),
];
